// @ts-ignore
import AtlanticNight from './themes/AtlanticNight.json'
// @ts-ignore
import AtomOneDark from './themes/AtomOneDark.json'
// @ts-ignore
import AuroraX from './themes/AuroraX.json'
// @ts-ignore
import AyuDark from './themes/AyuDark.json'
// @ts-ignore
import AyuLight from './themes/AyuLight.json'
// @ts-ignore
import BlulocoLight from './themes/BlulocoLight.json'
// @ts-ignore
import CodeSandBox from './themes/CodeSandBox.json'
// @ts-ignore
import Darktooth from './themes/Darktooth.json'
// @ts-ignore
import Dracula from './themes/Dracula.json'
// @ts-ignore
import EvaLight from './themes/EvaLight.json'
// @ts-ignore
import FlatUI from './themes/FlatUI.json'
// @ts-ignore
import Hopscotch from './themes/Hopscotch.json'
// @ts-ignore
import HorlaLightTheme from './themes/HorlaLightTheme.json'
// @ts-ignore
import HybridNext from './themes/HybridNext.json'
// @ts-ignore
import KimbieDark from './themes/KimbieDark.json'
// @ts-ignore
import Lucario from './themes/Lucario.json'
// @ts-ignore
import MonokaiDimmed from './themes/MonokaiDimmed.json'
// @ts-ignore
import MonokaiPro from './themes/MonokaiPro.json'
// @ts-ignore
import Nebula from './themes/Nebula.json'
// @ts-ignore
import NoctisAzureus from './themes/NoctisAzureus.json'
// @ts-ignore
import NoctisBordo from './themes/NoctisBordo.json'
// @ts-ignore
import NoctisLux from './themes/NoctisLux.json'
// @ts-ignore
import OneDarkPro from './themes/OneDarkPro.json'
// @ts-ignore
import OneMonokai from './themes/OneMonokai.json'
// @ts-ignore
import Panda from './themes/Panda.json'
// @ts-ignore
import RemedyDark from './themes/RemedyDark.json'
// @ts-ignore
import ReUI from './themes/ReUI.json'
// @ts-ignore
import ShadesOfPurple from './themes/ShadesOfPurple.json'
// @ts-ignore
import SnazzyLight from './themes/SnazzyLight.json'
// @ts-ignore
import SnazzyOperator from './themes/SnazzyOperator.json'
// @ts-ignore
import SublimeMaterialThemeDark from './themes/SublimeMaterialThemeDark.json'
// @ts-ignore
import SynthWave84 from './themes/SynthWave84.json'
// @ts-ignore
import TokyoNightStorm from './themes/TokyoNightStorm.json'
// @ts-ignore
import TomorrowNightBlue from './themes/TomorrowNightBlue.json'
// @ts-ignore
import Twilight from './themes/Twilight.json'

export const codeThemeList = [
  {
    name: 'Atlantic Night',
    value: 'AtlanticNight',
    custom: true,
    loaded: false,
    cache: '',
    data: AtlanticNight
  },
  {
    name: 'Atom One Dark',
    value: 'AtomOneDark',
    custom: true,
    loaded: false,
    cache: '',
    data: AtomOneDark
  },
  {
    name: 'Aurora X',
    value: 'AuroraX',
    custom: true,
    loaded: false,
    cache: '',
    data: AuroraX
  },
  {
    name: 'Ayu Dark',
    value: 'AyuDark',
    custom: true,
    loaded: false,
    cache: '',
    data: AyuDark
  },
  {
    name: 'Ayu Light',
    value: 'AyuLight',
    custom: true,
    loaded: false,
    cache: '',
    data: AyuLight
  },
  {
    name: 'Bluloco Light',
    value: 'BlulocoLight',
    custom: true,
    loaded: false,
    cache: '',
    data: BlulocoLight
  },
  {
    name: 'Code Sand Box',
    value: 'CodeSandBox',
    custom: true,
    loaded: false,
    cache: '',
    data: CodeSandBox
  },
  {
    name: 'Darktooth',
    value: 'Darktooth',
    custom: true,
    loaded: false,
    cache: '',
    data: Darktooth
  },
  {
    name: 'Dracula',
    value: 'Dracula',
    custom: true,
    loaded: false,
    cache: '',
    data: Dracula
  },
  {
    name: 'Eva Light',
    value: 'EvaLight',
    custom: true,
    loaded: false,
    cache: '',
    data: EvaLight
  },
  {
    name: 'Flat U I',
    value: 'FlatUI',
    custom: true,
    loaded: false,
    cache: '',
    data: FlatUI
  },
  {
    name: 'Hopscotch',
    value: 'Hopscotch',
    custom: true,
    loaded: false,
    cache: '',
    data: Hopscotch
  },
  {
    name: 'Horla Light Theme',
    value: 'HorlaLightTheme',
    custom: true,
    loaded: false,
    cache: '',
    data: HorlaLightTheme
  },
  {
    name: 'Hybrid Next',
    value: 'HybridNext',
    custom: true,
    loaded: false,
    cache: '',
    data: HybridNext
  },
  {
    name: 'Kimbie Dark',
    value: 'KimbieDark',
    custom: true,
    loaded: false,
    cache: '',
    data: KimbieDark
  },
  {
    name: 'Lucario',
    value: 'Lucario',
    custom: true,
    loaded: false,
    cache: '',
    data: Lucario
  },
  {
    name: 'Monokai Dimmed',
    value: 'MonokaiDimmed',
    custom: true,
    loaded: false,
    cache: '',
    data: MonokaiDimmed
  },
  {
    name: 'Monokai Pro',
    value: 'MonokaiPro',
    custom: true,
    loaded: false,
    cache: '',
    data: MonokaiPro
  },
  {
    name: 'Nebula',
    value: 'Nebula',
    custom: true,
    loaded: false,
    cache: '',
    data: Nebula
  },
  {
    name: 'Noctis Azureus',
    value: 'NoctisAzureus',
    custom: true,
    loaded: false,
    cache: '',
    data: NoctisAzureus
  },
  {
    name: 'Noctis Bordo',
    value: 'NoctisBordo',
    custom: true,
    loaded: false,
    cache: '',
    data: NoctisBordo
  },
  {
    name: 'Noctis Lux',
    value: 'NoctisLux',
    custom: true,
    loaded: false,
    cache: '',
    data: NoctisLux
  },
  {
    name: 'One Dark Pro',
    value: 'OneDarkPro',
    custom: true,
    loaded: false,
    cache: '',
    data: OneDarkPro
  },
  {
    name: 'One Monokai',
    value: 'OneMonokai',
    custom: true,
    loaded: false,
    cache: '',
    data: OneMonokai
  },
  {
    name: 'Panda',
    value: 'Panda',
    custom: true,
    loaded: false,
    cache: '',
    data: Panda
  },
  {
    name: 'Remedy Dark',
    value: 'RemedyDark',
    custom: true,
    loaded: false,
    cache: '',
    data: RemedyDark
  },
  {
    name: 'Re U I',
    value: 'ReUI',
    custom: true,
    loaded: false,
    cache: '',
    data: ReUI
  },
  {
    name: 'Shades Of Purple',
    value: 'ShadesOfPurple',
    custom: true,
    loaded: false,
    cache: '',
    data: ShadesOfPurple
  },
  {
    name: 'Snazzy Light',
    value: 'SnazzyLight',
    custom: true,
    loaded: false,
    cache: '',
    data: SnazzyLight
  },
  {
    name: 'Snazzy Operator',
    value: 'SnazzyOperator',
    custom: true,
    loaded: false,
    cache: '',
    data: SnazzyOperator
  },
  {
    name: 'Sublime Material Theme Dark',
    value: 'SublimeMaterialThemeDark',
    custom: true,
    loaded: false,
    cache: '',
    data: SublimeMaterialThemeDark
  },
  {
    name: 'Synth Wave84',
    value: 'SynthWave84',
    custom: true,
    loaded: false,
    cache: '',
    data: SynthWave84
  },
  {
    name: 'Tokyo Night Storm',
    value: 'TokyoNightStorm',
    custom: true,
    loaded: false,
    cache: '',
    data: TokyoNightStorm
  },
  {
    name: 'Tomorrow Night Blue',
    value: 'TomorrowNightBlue',
    custom: true,
    loaded: false,
    cache: '',
    data: TomorrowNightBlue
  },
  {
    name: 'Twilight',
    value: 'Twilight',
    custom: true,
    loaded: false,
    cache: '',
    data: Twilight
  }
]
